// Code generated by tygo. DO NOT EDIT.

//////////
// source: enums.go

export type ModuleType = string;
export const System: ModuleType = "S";
export const Process: ModuleType = "P";
export type ModuleStatus = string;
export const Applicable: ModuleStatus = "applicable";
export const Inapplicable: ModuleStatus = "inapplicable";
export const Excluded: ModuleStatus = "excluded";
